import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  uploadButton: {
    backgroundColor: theme.palette.BlueDownDark,
    color: 'white',
    '&:hover': {
      backgroundColor: theme.palette.BlueDownDark,
      opacity: 0.9,
    },
  },
  uploadButtonDisabled: {
    backgroundColor: 'grey',
  },
  input: {
    display: 'none',
  },
  fileTable: {
    marginTop: theme.spacing(1),
  },
}))

export default styles
